import type { UserWithPermissionsInDto } from 'shared/domain/user/types/inDto';
import { UserRole } from 'shared/types/userRole';
import { deepEqual } from 'shared/utils/deepEqual';
import type { UserPersonalDataPayload, UserStoreData } from './types';

export function createInitialUserState(): UserStoreData {
  return {
    isAuthenticated: false,
    user: {
      _id: '',
      email: '',
      permissions: [],
      personalData: [],
      basePermissions: {
        clients: [
          {
            _id: '',
            projects: [
              { role: UserRole.standard, _id: '', sites: [], processes: [] },
            ],
          },
        ],
      },
    },
  };
}

export function applyAuthSuccess(
  state: UserStoreData,
  user: UserWithPermissionsInDto
): UserStoreData {
  if (state.isAuthenticated && deepEqual(state.user, user)) {
    return state;
  }
  return { isAuthenticated: true, user };
}

export function applyModifyUserSuccess(
  state: UserStoreData,
  { personalData, superadminLabel = state.user.superadminLabel }: UserPersonalDataPayload
): UserStoreData {
  // Same data again (e.g. a repeated save) - keep the state reference so
  // `useUserStore.use.user()` subscribers do not re-render.
  if (deepEqual(state.user.personalData, personalData) && state.user.superadminLabel === superadminLabel) {
    return state;
  }
  return { ...state, user: { ...state.user, personalData, superadminLabel } };
}
